import BannerData from "../../model/top/bannerData";
import NewsData from "../../model/top/newsData";
import CharacterBannerData from "../../model/top/characterBannerData";
import RoadMapData from "../../model/top/roadmapData";
import { Api, MethodType, RequestType, ResponseType } from "../define";

// リクエスト
export type Request = RequestType & {
}

// レスポンス
export type Responce = ResponseType & {
    bannerInfo: BannerData[],
    characterInfo: CharacterBannerData,
    newsInfo: NewsData[],
    roadMapInfo: RoadMapData[],
}

export default class TopPageDataApi extends Api<Request, Responce>{
    // リクエストURL
    public url =  `${process.env.REACT_APP_URL}/webSite/toppageinfo`;
    
    // リクエストパラメータ
    public request: Request;

    // コンストラクター
    constructor(request: Request) {
        super(request);
        this.request = request;
        this.method = MethodType.POST;
    }

    //レスポンスパース処理
    public parseResponse(data: any): Responce {
        return data;
    }
}